import { Link } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';

import { useToast } from '@/hooks/use-toast';
import { CONTACT_EMAIL } from '@/lib/constants';

interface Props {
  service: string;
}

export const ImpactNotAvailable = ({ service }: Props): JSX.Element => {
  const { toast } = useToast();

  return (
    <div className="grow basis-0">
      <h2 className="text-2xl mb-4">
        <FormattedMessage id="coverage.details.impactNotAvailable.title" />
      </h2>
      <div className="flex flex-row items-center space-x-4">
        <span className="text-6xl">🕑</span>
        <ul className="space-y-2">
          <li>
            <FormattedMessage
              id="coverage.details.impactNotAvailable.text1"
              values={{ service }}
            />
          </li>
          <li>
            <FormattedMessage id="coverage.details.impactNotAvailable.text2" />
            &nbsp;
            <Link
              className="text-primary-500"
              onClick={() => {
                navigator.clipboard.writeText(CONTACT_EMAIL);
                toast({ title: 'global.copiedToClipboard' });
              }}
            >
              {CONTACT_EMAIL}
            </Link>
            &nbsp;
            <FormattedMessage id="coverage.details.impactNotAvailable.text3" />
          </li>
        </ul>
      </div>
    </div>
  );
};
